import React, { useState, useEffect } from "react";
import Select from "react-select";
import { primaryColor } from "../../Constants";


function CustomDropdown({
  value,
  name,
  handleChange,
  placeholder,
  options,
  handleGetOptionValue,
  handleGetOptionName,
  isDisabled = false,
  customClasses,
  
}) {
  const [isFocused, setIsFocused] = useState(false);


  useEffect(() => {
    if (value) {
      setIsFocused(true);
    }
  }, [value]);

  return (
    // <div className="relative w-full bg-white">
    <div className="relative w-full bg-gray-50 rounded-md">
      {/* Floating Label */}
      <label
        // className={`absolute left-3 transition-all z-10 text-gray-600 bg-white px-1
        //   ${
        //     isFocused || value
        //       ? "top-[-10px] text-xs text-primary px-1 bg-white"
        //       : "top-2/4 text-gray-500 text-sm -translate-y-1/2"
        //   }
        // `}
        className={`absolute left-2 transition-all duration-200 z-10 bg-gray-50 px-1 pointer-events-none
          ${
            isFocused || value
              ? "-top-3 text-sm text-primary"
              : "top-1/2 -translate-y-1/2 text-sm text-gray-400"
          }
        `}
      >
        {placeholder}
      </label>

      {/* Select Dropdown */}
      <Select
        value={value}
        name={name}
        onChange={(selectedOption) => {
          handleChange(selectedOption);
          setIsFocused(!!selectedOption);
        }}
        onFocus={() => setIsFocused(true)}
        onBlur={() => {
          if (!value) setIsFocused(false);
        }}
        className={`mt-1 ${customClasses}`}
        options={options || []}
        getOptionValue={handleGetOptionValue}
        getOptionLabel={handleGetOptionName}
        isDisabled={isDisabled}
        placeholder="" // Removes the extra "Select..." label
        menuPortalTarget={document.body} // ✅ Ensures menu appears above everything
        styles={{
          control: (base, state) => ({
            ...base,
            borderRadius: "0.3rem", 
            borderColor: value || state.isFocused ? primaryColor : "#6B7280",
            borderWidth: "2px",
            boxShadow: "none",
            "&:hover": {
              borderColor: primaryColor,
            },
            minHeight: "40px",
            height: "40px",
            // padding: "0 10px",
            paddingLeft: 8,
            paddingRight: 8,
            backgroundColor: "#FFFFFF", // bg-gray-50
            "&:hover": {
              borderColor: primaryColor,
            },
            fontSize: "1rem", // text-sm size
            color: "#374151", // text-gray-700
          }),
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999, // ✅ Higher z-index than the floating label
          }),
          menu: (base) => ({
            ...base,
            zIndex: 9999, // ✅ Ensures menu is always above
            fontSize: "1rem",
          }),
          valueContainer: (base) => ({
            ...base,
            padding: "6px 4px",
            height: 40,
          }),
          singleValue: (base) => ({
            ...base,
            color: "#000000",
            marginLeft: 0,           // <-- Remove any left margin to shift text left
          }),
          input: (base) => ({
            ...base,
            margin: 0,
            padding: 0,
            color: "#111827",
            fontSize: "1rem",        // <-- Bigger input text too
          }),
          placeholder: (base) => ({
            ...base,
            color: "#9CA3AF",
            fontWeight: 300,
            fontSize: "1rem",        // <-- Bigger placeholder text
            marginLeft: 0,
          }),
          indicatorsContainer: (base) => ({
            ...base,
            height: "36px",
          }),
          dropdownIndicator: (base) => ({
            ...base,
            padding: "6px",
            color: isFocused || value ? primaryColor : "#9CA3AF",
            "&:hover": {
              color: primaryColor,
            },
          }),
          clearIndicator: (base) => ({
            ...base,
            padding: 6,
            color: "#9CA3AF",
            "&:hover": {
              color: primaryColor,
            },
          }),
        }}
      />
    </div>
  );
}

export default CustomDropdown;